import { render } from "./leftmenu-layout.vue?vue&type=template&id=a621d202"
import script from "./leftmenu-layout.vue?vue&type=script&lang=ts"
export * from "./leftmenu-layout.vue?vue&type=script&lang=ts"

import "./leftmenu-layout.vue?vue&type=style&index=0&id=a621d202&lang=less"
script.render = render

export default script